import React from 'react';
import ReactDOM from 'react-dom';

// Libraries
import 'bootstrap/dist/css/bootstrap.min.css';

// CSS
// import './assets/css/components.css';
import './css-fix';
import './assets/css/index.css'; // NOTE overrides shoprite styles and Universal Styles
import './assets/css/fonts.css';
import './assets/css/pageTransitions.css';
import './assets/css/animations.css';
import './assets/css/bootstrapOverrides.css';
import './assets/css/utilities.css';

// Redux
import { Provider } from 'react-redux';
import store from './redux/store';

// App Routes
import Routes from './pages/routes';

// Helper Functions & Data
// import shopriteSSORedirectLink from './assets/js/shopriteSSORedirectLink.json';
// import searchForSigninButton from './assets/js/shopriteSignInButton'; // change ShopRite sign in button route
import fixShopriteLogo from './assets/js/fixShopriteLogo';
import { initAmplitude } from './amplitude';

// Initialize Helper Functions
// searchForSigninButton();
fixShopriteLogo();
initAmplitude();

ReactDOM.render(
  <Provider store={store}>
    <Routes />
  </Provider>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js